import { Form,   useLoaderData, Link } from "react-router-dom";
import React, { useEffect, useState, useRef, useCallback } from 'react';
import Table from 'react-bootstrap/Table';
import PermissionErrorPage from "../../pages/shared/permissionError";
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import { submissionService, questionService } from '../../services/api';
import { storageService } from '../../services/storage';
import { USER_ROLES } from '../../utils/constants';
import LoadingSpinner from '../ui/LoadingSpinner';
import { formatTimestamp } from '../../utils/dateUtils';
import { submissionsToCsv } from '../../utils/submissionsCsv';
import '../../styles/components/ui/tables.css';
import { useCourse } from "../../contexts/CourseContext";


function SubmissionTable() {
    const [submission, setSubmission] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { selectedCourse, courses, setCourses } = useCourse();
    const courseCrn = selectedCourse?.CRN ?? selectedCourse?.id;

    const fetchAllSubmissions = useCallback(async () => {
        if (!courseCrn) {
            console.log('No course selected, skipping fetch');
            return;
        }
        setIsLoading(true);
        try {
            const submissions = await submissionService.getAllSubmissionsByCourse(courseCrn);
            setSubmission(submissions);
        } catch (error) {
            console.error('Error fetching submissions:', error);
            alert('Failed to load submissions');
        } finally {
            setIsLoading(false);
        }
    }, [courseCrn]);

    const handleDownload = async () => {
        // Question names make the file readable; without them it still has ids.
        const questions = await questionService.getProblemsFromCourse(courseCrn).catch(() => []);
        const csv = submissionsToCsv(submission, Array.isArray(questions) ? questions : []);
        const url = window.URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = `${selectedCourse?.name || courseCrn}_submissions.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };

    useEffect(() => {
        fetchAllSubmissions();
    }, [fetchAllSubmissions]);
    return(
        <div className="table-container">
            {(storageService.getRole() === USER_ROLES.INSTRUCTOR) ? (
                <>
                <div className="table-header">
                    <h1 className="table-page-title">All Student Submissions</h1>
                    <p className="table-page-subtitle">Below are all the student submissions for this course.</p>
                    <Button
                        variant="primary"
                        onClick={handleDownload}
                        disabled={isLoading || submission.length === 0}
                    >
                        Download Submissions (CSV)
                    </Button>
                </div>
                <div className="table-wrapper">
            {isLoading ? (
                <LoadingSpinner text="Loading submissions..." />
            ) : (
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Time Stamp</th>
                                        <th>Question ID</th>
                                        <th>Student ID</th>
                                        <th>Code</th>
                                        <th className="table-cell-center">Was it Correct</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {submission.map((id, idx) => (
                                        <tr key={idx}>
                                            <td>{formatTimestamp(id.timestamp)}</td>
                                            <td>{id.qid}</td>
                                            <td>{id.sid}</td>
                                            <td>{id.code}</td>
                                            <td className="table-cell-center">{(id.status === "Passed")? (<div><Badge pill bg="success" text="light"> Yes </Badge></div>):(<div><Badge pill bg="danger" text="light"> No </Badge></div>)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
            )}
                </div>
        </>
        ):(
            <PermissionErrorPage/>
        )
        } 
    </div>
    );
}
export default SubmissionTable;